
<template>
<div class="row clearfix">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="">
        <div class="body">
          <ul class="tabMenu nav nav-tabs">
            <li class="nav-item" style="margin-bottom: -23px">
              <button class="tabButtons nav-link active" type="button">
                설정
              </button>
              &nbsp;&nbsp;
            </li>
            <li class="nav-item" style="margin-bottom: -23px">
              <button
                class="tabButtons nav-link"
                type="button"
                @click="toActionInput"
                :disabled="newOrNot"
              >
                인풋설정
              </button>
              &nbsp;&nbsp;
            </li>
            <li class="nav-item" style="margin-bottom: -23px">
              <button
                class="tabButtons nav-link"
                type="button"
                @click="toActionApi"
                :disabled="newOrNot"
              >
                API 설정
              </button>
              &nbsp;&nbsp;
            </li>
          </ul>

          <div class="tabContent tab-content">
            <div role="tabpanel" class="tab-pane in active">
              <dev-action-input-fields />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DevActionInputFields from "@/views/dev/action/DevActionInputFields";

export default {
  name: "DevActSetting",
  props: ["menuData"],
  components: {
    DevActionInputFields: DevActionInputFields,
  },
  data() {
    return {
      heading: this.menuData,
      newOrNot: false,
    };
  },
  methods: {
    toActionInput() {
      this.$router.push({
        name: "DevActInput",
        params: { appId: this.$route.params.appId },
      });
    },
    toActionApi() {
      this.$router.push({
        name: "DevActApi",
        params: { appId: this.$route.params.appId },
      });
    },
  },
  created() {
    console.log("DevActSetting.created");

    if (this.$store.state.devStore.title == "__new__") {
      this.newOrNot = true;
    }
  },
  mounted() {
    console.log("DevActSetting.mounted");
  },
  beforeDestroy() {
    console.log("DevActSetting.beforeDestroy");
  }
}
</script>
